
import api from "../../api";



export const getSession = async () => {

    const res = await api.get("talkjs/session/")

    return res.data 
}

export const getOther = async (data : { member_ids : string}) => {

    if (data.member_ids == "staff") {
        const res = await api.get(`talkjs/staff_user/`)
        return res.data 
    } else {
        const res = await api.get(`talkjs/user/`, { params : data })
        return res.data 
    }
    
}

export const getStaffContact = async () => {
    
    const res = await api.get(`talkjs/staff_user/`)
    return res.data 
        
}



export const getChats = async (data : {
    search ?: string,
    page_size ?: number,
    unreadsOnly ?: boolean,
}) => {

    const res = await api.get(`talkjs/conversations/`, { params : data })
    return res.data
}

export const postMessage = async (data : {
    receiver : string,
    text : string,
}) => {
    
    const res = await api.post(`talkjs/send/`, data)
    return res.data
}

export const sharePost = async (data : {
    receiver : string,
    text : string,

}) => {
    return api.post(`talkjs/send/`, data);
}

export const leaveConversation = async (data : {
    conversation_id : string,
}) => {
    const res = await api.delete(`talkjs/conversations/${data.conversation_id}/leave/`)
    return res.data
}
